import React, { ReactNode } from "react";

interface GeneralRadioProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name?: string;
  label: string | ReactNode;
  value?: string | number;
  checked?: boolean;
  onClick?: (event: any) => void;
  disabled?: boolean;
  className?: string;
  labelStyle?: string;
}

const GeneralRadio: React.FC<GeneralRadioProps> = ({
  name,
  label,
  value,
  checked,
  disabled,
  onClick,
  className,
  labelStyle,
  onChange,
  ...props
}) => {
  return (
    <div className="flex items-center">
      <label
        className={`relative flex ${disabled ? "" : "cursor-pointer"} items-center gap-2`}
      >
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onClick={onClick}
          className="hidden"
          onChange={(e) => {
            onChange && onChange(e);
          }}
        />
        <div
          className={`h-6 w-6 border-[3px] ${
            checked ? "border-primary" : ""
          } flex items-center justify-center rounded-full transition-colors`}
        >
          <div
            className={`h-2 w-2 transform rounded-full bg-primary transition-transform duration-500 ${
              checked ? "scale-100" : "scale-0"
            }`}
          ></div>
        </div>
        <span
          className={`text-md ${className} ${
            checked
              ? `font-bold text-primary ${labelStyle}`
              : `text-body-text ${labelStyle}`
          } transition-colors`}
        >
          {label}
        </span>
      </label>
    </div>
  );
};

export default GeneralRadio;
